import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import PostView from "@/components/PostView";

export default function PreviewPage() {
  const { id } = useParams();
  const [post, setPost] = useState(undefined);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/admin/posts/${id}`).then((res) => setPost(res.data)).catch(() => setPost(null));
  }, [id]);

  if (post === undefined) return <div style={{ padding: 48, fontFamily: '"Helvetica Neue", Arial' }}>Loading preview&hellip;</div>;
  if (post === null)
    return (
      <div style={{ padding: 48, fontFamily: '"Helvetica Neue", Arial' }}>
        Preview not found. <Link to="/admin">Back to admin</Link>
      </div>
    );
  return <PostView post={post} preview />;
}
